import { render, staticRenderFns } from "./soporteChat.vue?vue&type=template&id=e52cd97e&scoped=true&"
import script from "./soporteChat.vue?vue&type=script&lang=js&"
export * from "./soporteChat.vue?vue&type=script&lang=js&"
import style0 from "./soporteChat.vue?vue&type=style&index=0&id=e52cd97e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e52cd97e",
  null
  
)

export default component.exports